<template>
  <div class="limits-carousel" v-show="hasLimits">
    <v-card class="elevation-0 limits-carousel__subtitle">
      {{ $t('business_limits') }}
      <Tooltip
        :text="$t('business_limits_tooltip')"
        :link="limitsLink"
        position="top"
        :delay="1000"
      />
    </v-card>

    <v-btn
      v-if="isSliderNeeded"
      class="limits-carousel__controls"
      elevation="0"
      color="white"
      @click="prev"
    >
      <v-icon>chevron_left</v-icon>
    </v-btn>

    <!-- 180px Buiness limits label -->
    <!-- 96px Controls buttons -->
    <span v-if="isSliderNeeded" style="width: calc(100% - 96px - 180px)">
      <VueTinySlider
        ref="tinySlider"
        :options="options"
      >
        <div
          v-for="limit in limits"
          :key="limit.title"
        >
          <LimitsItem
            :title="limit.title"
            :limits="limit"
          />
        </div>
      </VueTinySlider>
    </span>

    <div
      v-else
      class="limits-carousel__no-scroll"
      style="width: calc(100% - 180px)"
    >
      <div
        v-for="limit in limits"
        :key="limit.title"
      >
        <LimitsItem
          :title="limit.title"
          :limits="limit"
        />
      </div>
    </div>

    <v-btn
      v-if="isSliderNeeded"
      class="limits-carousel__controls"
      elevation="0"
      color="white"
      @click="next"
    >
      <v-icon>chevron_right</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import VueTinySlider from "@mentorkadriu/vue-tiny-slider";
  import Tooltip from './tooltips/Tooltip';
  import LimitsItem from "@/components/LimitsItem.vue";

  export default {
    components: {
      Tooltip,
      LimitsItem,
      VueTinySlider
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowWidth = window.innerWidth
        })
      })
    },
    data() {
      return {
        progress: 65,
        limitsLink: import.meta.env.VUE_APP_HELP_LIMITS_URL,
        windowWidth: window.innerWidth,
        options: {
          mouseDrag: true,
          loop: true,
          nav: false,
          slideBy: 'page',
          controls: false,
          arrowKeys: false,
          swipeAngle: false,
          items: 3,
          gutter: 8,
          edgePadding: 50,
          responsive: {
            1660: {
              items: 4
            }
          }
        }
      };
    },
    computed: {
      isSliderNeeded() {
        if ( this.windowWidth < 1660 ) {
          return this.limits?.length > 3;
        } else {
          return this.limits?.length > 4;
        }
      },
      limits() {
        return this.$store.getters['businessUsers/limits'];
      },
      hasLimits() {
        return this.limits.length > 0;
      },
    },
    created() {
      this.getLimits();
    },
    methods: {
      next() {
        this.$refs.tinySlider.getSlider().goTo('next');
      },
      prev() {
        this.$refs.tinySlider.getSlider().goTo('prev');
      },
      getLimits() {
        return this.$store.dispatch('businessUsers/getLimits');
      },
      onResize() {
        this.windowWidth = window.innerWidth
      }
    }
  };
</script>

<style lang="scss">
@use 'sass:map';
  @use '../assets/styles/theme' as *;
  @use './tiny-slider/src/tiny-slider' as *;

  .limits-carousel {
    display: flex;
    justify-content: space-between;

    &__no-scroll {
      display: flex;
      justify-content: flex-start;
      gap: 8px;
    }

    &__subtitle {
      align-items: center;
      justify-content: center;
      font-weight: bold;
      gap: 8px;
      display: flex;
      font-size: 16px;
      padding: 22px 16px;

      i {
        color: map.get($colors, text) !important;
      }
    }

    &__controls {
      &.v-btn {
        border-radius: 8px;
        min-width: 40px;
        max-width: 40px;
        height: 68px;
      }

      i.v-icon {
        margin-right: 0 !important;
      }
    }
  }
</style>
